module.exports = __webpack_public_path__ + "img/fi.079f4bcb.svg";